<template>
  <ul>
    <!-- Dashboard -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightZunoHome = true"
      @mouseleave="dropRightZunoHome = false"
    >
      <NuxtLink
        to="/admin/home"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Home"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <HomeSmall
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Home</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightZunoHome"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/admin/home"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Home</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Reporting Frameworks -->
    <li
      v-if="$store.auth.authenticatedUser.is_super_typewriter"
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightReporting = true"
      @mouseleave="dropRightReporting = false"
    >
      <NuxtLink
        to="/admin/reporting-frameworks"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Reporting Frameworks"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <ReportingIcon
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Reporting Frameworks</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightReporting"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/admin/reporting-frameworks"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Reporting Frameworks</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Question Bank -->
    <li
      v-if="$store.auth.authenticatedUser.is_super_typewriter"
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightQBank = true"
      @mouseleave="dropRightQBank = false"
    >
      <NuxtLink
        to="/admin/question-bank"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Question Bank"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <BankIcon
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Question and Metric Bank</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightQBank"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/admin/question-bank"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Question and Metric Bank</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Emission Factor Sources -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightSources = true"
      @mouseleave="dropRightSources = false"
    >
      <NuxtLink
        to="/admin/sources"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Sources"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <GHGIcon
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Sources</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightSources"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/admin/sources"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Sources</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Emission Factor Activities -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightActivities = true"
      @mouseleave="dropRightActivities = false"
    >
      <NuxtLink
        to="/admin/activities"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Activities"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <BuildingIcon
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Activities</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightActivities"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/admin/activities"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Activities</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- ESG Data Transformation -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightActivities = true"
      @mouseleave="dropRightActivities = false"
    >
      <NuxtLink
        to="/admin/data-transformation"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Data Transformation"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <BuildingIcon
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Data Transformation</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightActivities"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/admin/activities"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Data Transformation</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Emission Factor Activities -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightRegions = true"
      @mouseleave="dropRightRegions = false"
    >
      <NuxtLink
        to="/admin/regions"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Regions"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <GlobeIcon
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Regions</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightRegions"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/admin/regions"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Regions</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Emission Factors -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightEFDB = true"
      @mouseleave="dropRightEFDB = false"
    >
      <NuxtLink
        to="/admin/emission-factors"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title=" Emission Factors"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <ViewLog
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Emission Factors</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightEFDB"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/admin/emission-factors"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Emission Factors</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Emission Factors Groups -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightGroups = true"
      @mouseleave="dropRightGroups = false"
    >
      <NuxtLink
        to="/admin/groups"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Groups"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <FourSquares
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Groups</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightGroups"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/admin/groups"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Groups</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Types -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightTypes = true"
      @mouseleave="dropRightTypes = false"
    >
      <NuxtLink
        to="/admin/types/"
        class="relative z-10 block truncate text-gray-200 transition duration-150 hover:text-white"
        title="Types"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{
            'justify-center p-0': !sideBarActive,
            'md:px-3 md:py-3 lg:px-3': sideBarActive,
          }"
        >
          <div
            class="menu-inner flex"
            :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
          >
            <LayerPlus
              class="h-5 w-5 text-sidebar-green-tertiary"
              :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
            />
            <span
              class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': sideBarActive }"
            >Types</span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightTypes"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col bg-sidebar-green-primary p-3">
          <NuxtLink
            to="/admin/types/"
            class="text-sm text-sidebar-green-tertiary"
          >
            <span>Types</span>
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Pollutants -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightPollutants = true"
      @mouseleave="dropRightPollutants = false"
    >
      <div class="relative z-20 block">
        <div>
          <div
            class="block cursor-pointer truncate text-gray-200 transition duration-150 hover:text-white"
            title="Pollutants"
            @click="showPollutants = !showPollutants"
          >
            <div
              class="relative z-10 flex items-center justify-between py-3 md:py-3"
              :class="{
                'justify-center p-0': !sideBarActive,
                'md:px-3 md:py-3 lg:px-3': sideBarActive,
              }"
            >
              <div
                class="menu-inner flex"
                :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
              >
                <CarbonFire
                  class="text-sidebar-green-tertiary"
                  :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
                />
                <span
                  class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
                  :class="{ 'md:hidden lg:block': sideBarActive }"
                >Pollutants</span>
              </div>
              <div
                class="hidden transition-all"
                :class="{
                  'md:hidden lg:block': sideBarActive,
                  'rotate-180': showPollutants,
                }"
              >
                <span class="text-sidebar-green-tertiary md:ml-2 lg:ml-0">
                  <ChevronDownLarge custom-style="h-5 w-5" />
                </span>
              </div>
            </div>
          </div>
          <div
            class="transition-[grid-template-rows]"
            :class="{ '!hidden': !sideBarActive, 'grid': sideBarActive }"
            :style="{ 'grid-template-rows': showPollutants ? '1fr' : '0fr' }"
          >
            <div class="overflow-hidden">
              <NuxtLink
                to="/admin/pollutants"
                class="block truncate py-2 text-gray-200 transition duration-150 hover:text-white"
                title="Show All"
              >
                <div class="menu-child flex items-center">
                  <span
                    class="lg:sidebar-expanded:opacity-100 2xl:opaci-2ty-100 ml-14 hidden text-sm font-medium text-sidebar-green-tertiary duration-200"
                    :class="{ 'md:hidden lg:block': sideBarActive }"
                  >Show All</span>
                </div>
              </NuxtLink>
              <NuxtLink
                to="/admin/pollutants/create"
                class="block truncate py-2 text-gray-200 transition duration-150 hover:text-white"
                title="Create"
              >
                <div class="menu-child flex items-center">
                  <span
                    class="lg:sidebar-expanded:opacity-100 2xl:opaci-2ty-100 ml-14 hidden text-sm font-medium text-sidebar-green-tertiary duration-200"
                    :class="{ 'md:hidden lg:block': sideBarActive }"
                  >Create</span>
                </div>
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightPollutants"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col gap-y-2 bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col">
          <div class="w-full bg-sidebar-green-primary p-3 pb-0">
            <span class="text-sm font-medium text-white">Pollutants</span>
            <div class="mt-3 h-0.5 w-full bg-gray-100/10" />
          </div>
          <div class="flex flex-col gap-y-4 bg-sidebar-green-primary p-4">
            <NuxtLink
              to="/admin/pollutants"
              class="text-sm text-sidebar-green-tertiary"
            >
              <span>Show All</span>
            </NuxtLink>
            <NuxtLink
              to="/admin/pollutants/create"
              class="text-sm text-sidebar-green-tertiary"
            >
              <span>Create</span>
            </NuxtLink>
          </div>
        </div>
      </div>
    </li>

    <!-- Units -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightUnits = true"
      @mouseleave="dropRightUnits = false"
    >
      <div class="relative z-20 block">
        <div>
          <div
            class="block cursor-pointer truncate text-gray-200 transition duration-150 hover:text-white"
            title="Units"
            @click="showUnits = !showUnits"
          >
            <div
              class="relative z-10 flex items-center justify-between py-3 md:py-3"
              :class="{
                'justify-center p-0': !sideBarActive,
                'md:px-3 md:py-3 lg:px-3': sideBarActive,
              }"
            >
              <div
                class="menu-inner flex"
                :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
              >
                <UnitsIcon
                  class="h-5 w-5 text-sidebar-green-tertiary"
                  :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
                />
                <span
                  class="lg:sidebar-expanded:opacity-100 ml-1 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
                  :class="{ 'md:hidden lg:block': sideBarActive }"
                >Units</span>
              </div>
              <div
                class="hidden transition-all"
                :class="{
                  'md:hidden lg:block': sideBarActive,
                  'rotate-180': showUnits,
                }"
              >
                <span class="text-sidebar-green-tertiary md:ml-2 lg:ml-0">
                  <ChevronDownLarge custom-style="h-5 w-5" />
                </span>
              </div>
            </div>
          </div>
          <div
            class="transition-[grid-template-rows]"
            :class="{ '!hidden': !sideBarActive, 'grid': sideBarActive }"
            :style="{ 'grid-template-rows': showUnits ? '1fr' : '0fr' }"
          >
            <div class="overflow-hidden">
              <NuxtLink
                to="/admin/units"
                class="block truncate py-2 text-gray-200 transition duration-150 hover:text-white"
                title="Show All"
              >
                <div class="menu-child flex items-center">
                  <span
                    class="lg:sidebar-expanded:opacity-100 2xl:opaci-2ty-100 ml-14 hidden text-sm font-medium text-sidebar-green-tertiary duration-200"
                    :class="{ 'md:hidden lg:block': sideBarActive }"
                  >Show All</span>
                </div>
              </NuxtLink>
              <NuxtLink
                to="/admin/units/create"
                class="block truncate py-2 text-gray-200 transition duration-150 hover:text-white"
                title="Create"
              >
                <div class="menu-child flex items-center">
                  <span
                    class="lg:sidebar-expanded:opacity-100 2xl:opaci-2ty-100 ml-14 hidden text-sm font-medium text-sidebar-green-tertiary duration-200"
                    :class="{ 'md:hidden lg:block': sideBarActive }"
                  >Create</span>
                </div>
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightUnits"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col gap-y-2 bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col">
          <div class="w-full bg-sidebar-green-primary p-3 pb-0">
            <span class="text-sm font-medium text-white">Units</span>
            <div class="mt-3 h-0.5 w-full bg-gray-100/10" />
          </div>
          <div class="flex flex-col gap-y-4 bg-sidebar-green-primary p-4">
            <NuxtLink
              to="/admin/units"
              class="text-sm text-sidebar-green-tertiary"
            >
              <span>Show All</span>
            </NuxtLink>
            <NuxtLink
              to="/admin/units/create"
              class="text-sm text-sidebar-green-tertiary"
            >
              <span>Create</span>
            </NuxtLink>
          </div>
        </div>
      </div>
    </li>

    <!-- Settings -->
    <li
      class="relative mb-0.5 select-none rounded-sm last:mb-0"
      @mouseover="dropRightZunoSettings = true"
      @mouseleave="dropRightZunoSettings = false"
    >
      <div class="relative z-20 block">
        <div>
          <div
            class="block cursor-pointer truncate text-gray-200 transition duration-150 hover:text-white"
            title="Settings"
            @click="showSettings = !showSettings"
          >
            <div
              class="relative z-10 flex items-center justify-between py-3 md:py-3"
              :class="{
                'justify-center p-0': !sideBarActive,
                'md:px-3 md:py-3 lg:px-3': sideBarActive,
              }"
            >
              <div
                class="menu-inner flex"
                :class="{ 'mx-auto': !sideBarActive, 'm-0': sideBarActive }"
              >
                <CogIcon
                  class="text-sidebar-green-tertiary"
                  :class="{ 'mr-0': !sideBarActive, 'mr-3': sideBarActive }"
                />
                <span
                  class="lg:sidebar-expanded:opacity-100 hidden text-sm font-medium text-sidebar-green-tertiary duration-200 2xl:opacity-100"
                  :class="{ 'md:hidden lg:block': sideBarActive }"
                >Settings</span>
              </div>
              <div
                class="hidden transition-all"
                :class="{
                  'md:hidden lg:block': sideBarActive,
                  'rotate-180': showSettings,
                }"
              >
                <span class="text-sidebar-green-tertiary md:ml-2 lg:ml-0">
                  <ChevronDownLarge custom-style="h-5 w-5" />
                </span>
              </div>
            </div>
          </div>
          <div
            class="transition-[grid-template-rows]"
            :class="{ '!hidden': !sideBarActive, 'grid': sideBarActive }"
            :style="{ 'grid-template-rows': showSettings ? '1fr' : '0fr' }"
          >
            <div class="overflow-hidden">
              <NuxtLink
                to="/admin/settings/invite-engineers"
                class="mb-4 mt-4 block truncate text-gray-200 transition duration-150 hover:text-white"
                title="Invite Engineers"
              >
                <div class="menu-child flex items-center">
                  <span
                    class="lg:sidebar-expanded:opacity-100 2xl:opaci-2ty-100 ml-14 hidden text-sm font-medium text-sidebar-green-tertiary duration-200"
                    :class="{ 'md:hidden lg:block': sideBarActive }"
                  >Invite Engineers</span>
                </div>
              </NuxtLink>
              <NuxtLink
                to="/admin/settings/add-admins"
                class="mb-4 mt-4 block truncate text-gray-200 transition duration-150 hover:text-white"
                title="Add Admins"
              >
                <div class="menu-child flex items-center">
                  <span
                    class="lg:sidebar-expanded:opacity-100 2xl:opaci-2ty-100 ml-14 hidden text-sm font-medium text-sidebar-green-tertiary duration-200"
                    :class="{ 'md:hidden lg:block': sideBarActive }"
                  >Add Admins</span>
                </div>
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightZunoSettings"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] flex-col gap-y-2 bg-gray-200 md:left-12 lg:left-11"
        :class="{ '!hidden': sideBarActive }"
      >
        <div class="flex flex-col">
          <div class="w-full bg-sidebar-green-primary p-3 pb-0">
            <span class="text-sm font-medium text-white">Settings</span>
            <div class="mt-3 h-0.5 w-full bg-gray-100/10" />
          </div>
          <div class="flex flex-col gap-y-4 bg-sidebar-green-primary p-4">
            <NuxtLink
              to="/admin/settings/invite-engineers"
              class="text-sm text-sidebar-green-tertiary"
            >
              <span>Invite Engineers</span>
            </NuxtLink>
            <NuxtLink
              to="/admin/settings/add-admins"
              class="text-sm text-sidebar-green-tertiary"
            >
              <span>Add Admins</span>
            </NuxtLink>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ZunoEngineerMenu',

  data() {
    return {
      showSettings: false,
      showPollutants: false,
      showUnits: false,
      isCompanyAdmin: false,
      dropRightZunoHome: false,
      // dropRightForms: false,
      dropRightReporting: false,
      dropRightTypes: false,
      dropRightPollutants: false,
      dropRightUnits: false,
      dropRightZunoSettings: false,
      dropRightQBank: false,
      dropRightEFDB: false,
      dropRightSources: false,
      dropRightActivities: false,
      dropRightRegions: false,
      dropRightGroups: false,
    }
  },

  computed: {
    active() {
      return this.$store.sidebar.isActive
    },
    sideBarActive() {
      return this.$store.sidebar.responsiveActive
    },
  },

  mounted() {
    this.showSettings = false
    this.showPollutants = false
    this.showUnits = false
    setTimeout(() => {
      const user = this.$store.auth.authenticatedUser

      if (user?.is_superuser || user?.is_zuno_engineer) return
      const cid = JSON.parse(localStorage.getItem('cid'))
      this.isCompanyAdmin = JSON.parse(localStorage.getItem('companies')).find(
        ({ id }) => id === cid,
      ).is_member_admin
    }, 2000)
  },
}
</script>

<style scoped>
.nuxt-link-active div {
  background-color: #87bda651;
  border-radius: 5px;
}

.nuxt-link-active span {
  color: #ffffff !important;
}

.nuxt-link-active .menu-inner {
  background-color: transparent;
  border-radius: 0px;
}

.nuxt-link-active .menu-child {
  padding: 8px 0px;
}
</style>
